import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful';
import type { TypeBlockAccordionContentSkeleton } from './TypeBlockAccordionContent';
import type { TypeBlockClientTestimonialSkeleton } from './TypeBlockClientTestimonial';
import type { TypeBlockFeaturedCaseStudiesSkeleton } from './TypeBlockFeaturedCaseStudies';
import type { TypeBlockGradientCtaSkeleton } from './TypeBlockGradientCta';
import type { TypeBlockIconBlocksSkeleton } from './TypeBlockIconBlocks';
import type { TypeBlockImageSkeleton } from './TypeBlockImage';
import type { TypeBlockImageWithPartialOverlaySkeleton } from './TypeBlockImageWithPartialOverlay';
import type { TypeBlockIndustryBlocksSkeleton } from './TypeBlockIndustryBlocks';
import type { TypeBlockJobListSkeleton } from './TypeBlockJobList';
import type { TypeBlockLogoCarouselSkeleton } from './TypeBlockLogoCarousel';
import type { TypeBlockLogoGridSkeleton } from './TypeBlockLogoGrid';
import type { TypeBlockNumberedBlocksSkeleton } from './TypeBlockNumberedBlocks';
import type { TypeBlockPageSectionSkeleton } from './TypeBlockPageSection';
import type { TypeBlockPeopleListSkeleton } from './TypeBlockPeopleList';
import type { TypeBlockRichTextSkeleton } from './TypeBlockRichText';
import type { TypeBlockScrolljackSectionSkeleton } from './TypeBlockScrolljackSection';
import type { TypeBlockSlideshowSkeleton } from './TypeBlockSlideshow';
import type { TypeBlockStackedCardsSkeleton } from './TypeBlockStackedCards';
import type { TypeBlockTabbedContentSkeleton } from './TypeBlockTabbedContent';
import type { TypeBlockTechnologyBlocksSkeleton } from './TypeBlockTechnologyBlocks';

export interface TypeBlockDarkCircleBackgroundFields {
    internalName?: EntryFieldTypes.Symbol;
    overline?: EntryFieldTypes.Symbol;
    headerText?: EntryFieldTypes.Text;
    block?: EntryFieldTypes.EntryLink<
        TypeBlockIconBlocksSkeleton | TypeBlockIndustryBlocksSkeleton | TypeBlockNumberedBlocksSkeleton
    >;
    blocks?: EntryFieldTypes.Array<
        EntryFieldTypes.EntryLink<
            | TypeBlockAccordionContentSkeleton
            | TypeBlockClientTestimonialSkeleton
            | TypeBlockFeaturedCaseStudiesSkeleton
            | TypeBlockGradientCtaSkeleton
            | TypeBlockIconBlocksSkeleton
            | TypeBlockImageSkeleton
            | TypeBlockImageWithPartialOverlaySkeleton
            | TypeBlockIndustryBlocksSkeleton
            | TypeBlockJobListSkeleton
            | TypeBlockLogoCarouselSkeleton
            | TypeBlockLogoGridSkeleton
            | TypeBlockNumberedBlocksSkeleton
            | TypeBlockPageSectionSkeleton
            | TypeBlockPeopleListSkeleton
            | TypeBlockRichTextSkeleton
            | TypeBlockScrolljackSectionSkeleton
            | TypeBlockSlideshowSkeleton
            | TypeBlockStackedCardsSkeleton
            | TypeBlockTabbedContentSkeleton
            | TypeBlockTechnologyBlocksSkeleton
        >
    >;
    style: EntryFieldTypes.Symbol<'circle' | 'flat'>;
}

export type TypeBlockDarkCircleBackgroundSkeleton = EntrySkeletonType<
    TypeBlockDarkCircleBackgroundFields,
    'blockDarkCircleBackground'
>;
export type TypeBlockDarkCircleBackground<
    Modifiers extends ChainModifiers,
    Locales extends LocaleCode = LocaleCode,
> = Entry<TypeBlockDarkCircleBackgroundSkeleton, Modifiers, Locales>;

export function isTypeBlockDarkCircleBackground<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
    entry: Entry<EntrySkeletonType, Modifiers, Locales>
): entry is TypeBlockDarkCircleBackground<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'blockDarkCircleBackground';
}
